import { render, staticRenderFns } from "./areaPowerDifference.vue?vue&type=template&id=13c2fc27&scoped=true&"
import script from "./areaPowerDifference.vue?vue&type=script&lang=js&"
export * from "./areaPowerDifference.vue?vue&type=script&lang=js&"
import style0 from "./areaPowerDifference.vue?vue&type=style&index=0&id=13c2fc27&scoped=true&lang=css&"
import style1 from "./areaPowerDifference.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c2fc27",
  null
  
)

export default component.exports